import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";
import chalk from "../../assets/images/about/image.png";

const Banner = () => {
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("all");
  const [categories, setCategories] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  const navigate = useNavigate();

  /* ===================== HELPERS ===================== */
  const normalize = (v = "") =>
    v.toLowerCase().trim().replace(/\s+/g, " ");

  /* ===================== FETCH CATEGORIES ===================== */
  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/arts-categories")
      .then(res => res.json())
      .then(data => {
        if (data.success) setCategories(data.categories);
      })
      .catch(() => setCategories([]));
  }, []);

  /* ===================== LIVE SUGGESTIONS ===================== */
  useEffect(() => {
    if (!query.trim()) {
      setSuggestions([]);
      return;
    }

    const controller = new AbortController();
    const search = normalize(query);

    const loadSuggestions = async () => {
      try {

        const keywords = search.split(" ").filter(k => k.length > 0);
        const params = new URLSearchParams();
         keywords.forEach(keyword => {
          params.append("q", keyword);
        });

        // 🎯 Category filter ONLY if selected
        if (category !== "all") {
          const selectedCat = categories.find(
            c => Number(c.id) === Number(category)
          );
          if (selectedCat) {
            params.append("category", selectedCat.category_name);
          }
        }

        const res = await fetch(
          `https://kalakakshaaha.com/kks/api/tutors-search?${params.toString()}`,
          { signal: controller.signal }
        );

        const data = await res.json();

        if (data.success && Array.isArray(data.tutors)) {
        
          const unique = [];
          const seen = new Set();

          data.tutors.forEach(t => {
            if (!t.full_name || !t.city_name || !t.category_name || !t.skill_names) return;

            const key = `${t.full_name}-${t.city_name}-${t.category_name}-${t.skill_names}`;
            if (!seen.has(key)) {
              seen.add(key);
              unique.push(t);
            }
          });

          setSuggestions(unique.slice(0, 8));
        } else {
          setSuggestions([]);
        }
       } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Suggestion error:", err);
        }
       }
       };

       loadSuggestions();
       return () => controller.abort();
    }, [query, category, categories]);

  /* ===================== SEARCH SUBMIT ===================== */
  const handleSearch = async (e) => {
  e.preventDefault();
const search = normalize(query);

// If nothing typed
if (!search) {

  // Category selected (Dance, Music, etc.)
  if (category !== "all") {
    const selectedCat = categories.find(
      c => Number(c.id) === Number(category)
    );

    if (selectedCat) {
      navigate(`/tutors/${selectedCat.category_name}`);
      return;
    }
  }

  // If "All" selected
  navigate("/tutors/all");
  return;
}

  try {

    const keywords = search.split(" ").filter(k => k.length > 0);
    const params = new URLSearchParams();
     keywords.forEach(keyword => {
        params.append("q", keyword);
      });

    if (category !== "all") {
      const selectedCat = categories.find(
        c => Number(c.id) === Number(category)
      );
      if (selectedCat) {
        params.append("category", selectedCat.category_name);
      }
    }
    
    const res = await fetch(
      `https://kalakakshaaha.com/kks/api/tutors-search?${params.toString()}`
    );

    const data = await res.json();

    if (!data.success || !data.tutors || data.tutors.length === 0) {
      alert("No matching tutor found");
      return;
    }

    // ✅ FIXED LOGIC
    let resolvedCategory = "all";

    if (category !== "all") {
      const selectedCat = categories.find(
        c => Number(c.id) === Number(category)
      );
      if (selectedCat) resolvedCategory = selectedCat.category_name;
    }


     

    // PINCODE SEARCH
    if (/^\d{5,6}$/.test(search)) {
      navigate(`/tutors/${resolvedCategory}?pincode=${search}`);
      return;
    }

    // GENERAL SEARCH
   const queryString = keywords.map(k => `q=${encodeURIComponent(k)}`).join("&");
     navigate(`/tutors/${resolvedCategory}?q=${encodeURIComponent(search)}`);

  } catch (err) {
    console.error("Search error:", err);
    alert("Search failed. Please try again.");
  }
};
const sortedSuggestions = [...suggestions].sort((a, b) =>
  a.full_name.toLowerCase().localeCompare(b.full_name.toLowerCase())
);

  /* ===================== RENDER ===================== */
  return (
    <section className="blackboard-main-section">
      <div className="blackboard-container">
        {query && (
          <p className="top-text">
            {category === "all"
              ? "All Categories"
              : categories.find(c => c.id === Number(category))?.category_name}
            {" → "}
            {query}
            <img src={chalk} alt="chalk" className="chalk-img" />
          </p>
        )}
      </div>

      <form onSubmit={handleSearch} className="search-wrapper">
        {/* CATEGORY DROPDOWN */}
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="search-dropdown"
        >
          <option value="all">All</option>
          {categories.map(cat => (
            <option key={cat.id} value={cat.id}>
              {cat.category_name}
            </option>
          ))}
        </select>

        {/* SEARCH INPUT */}
        <div className="search-input-box">
          <input
            type="text"
            placeholder="Search Category,Skill,City,Tutor, or Pincode..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="search-input"
            autoComplete="off"
          />

          {/* 🔽 SUGGESTIONS */}
          {suggestions.length > 0 && (
            <div className="suggestion-box">
              {sortedSuggestions.map((tutor) => (
                <div
                  key={tutor.user_id}
                  className="suggestion-item"
                  onClick={() => {
                    setSuggestions([]);
                    setQuery("");

                    navigate(
                      `/tutor/${tutor.full_name
                        .toLowerCase()
                        .replace(/\s+/g, "-")}-${tutor.city_id}?id=${tutor.user_id}`
                    );
                  }}
                >
                  {`${tutor.full_name} — ${tutor.city_name} (${tutor.category_name}) (${tutor.skill_names})`}
                </div>
              ))}

            </div>
          )}
        </div>

        <button type="submit" className="search-btn">
          Search
        </button>
      </form>
    </section>
  );
};

export default Banner;
